import { compareSelectLabels } from '../../../helpers/compareSelectLabels'
import type { InventorySystemProfileDTO, TenantGroupDTO } from '../../../types'
import type { InventorySystemProfilePickerOption } from '../InventorySystemProfilesPicker.types'

export function buildInventorySystemProfilePickerOptions(
  profiles: readonly InventorySystemProfileDTO[],
  tenantGroups: readonly TenantGroupDTO[],
  selectedIds: readonly string[]
): InventorySystemProfilePickerOption[] {
  const groupById = new Map(tenantGroups.map((group) => [group.id, group]))
  const selectedProfiles = profiles.filter((profile) =>
    selectedIds.includes(profile.id)
  )
  const formatProfileLabel = (profile: InventorySystemProfileDTO) =>
    `${profile.code} (${profile.id})`
  return profiles
    .map((profile) => {
      const blockingProfile = selectedProfiles.find(
        (selected) =>
          selected.id !== profile.id &&
          selected.tenantGroupId === profile.tenantGroupId
      )
      return {
        id: profile.id,
        label: formatProfileLabel(profile),
        tenantGroupLabel:
          groupById.get(profile.tenantGroupId)?.code ?? profile.tenantGroupId,
        blockingLabel: blockingProfile
          ? formatProfileLabel(blockingProfile)
          : null,
      }
    })
    .sort((left, right) => compareSelectLabels(left.label, right.label))
}
